'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircleIcon, ShareIcon } from '@heroicons/react/24/outline';

import { useState } from 'react';

export default function ShareButton() {
  const [copied, setCopied] = useState(false);

  const handleShare = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    }
  };

  return (
    <div className="relative flex items-center">
      <motion.button
        onClick={handleShare}
        className="flex items-center gap-2 text-primary text-lg hover:text-blue-700"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <ShareIcon className="w-6 h-6" />
      </motion.button>

      <AnimatePresence>
        {copied && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            role="alert"
            className="alert alert-success fixed bottom-5 left-1/2 transform -translate-x-1/2 z-[9999] bg-green-500 text-white px-4 py-3 flex items-center gap-2"
          >
            <CheckCircleIcon className="w-5 h-5" />
            <span>Link Copied!</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
